import React from 'react';

import styles from './styles/summary-card.module.css';

export default function SummaryCard({ Img, title, content }) {
    return (
        <div className={styles.wrapper}>
            <div>
                <Img />
            </div>
            <p className={styles.title}>{title}</p>
            <p className={styles.content}>{content}</p>
        </div>
    );
}
